const getDistanceBranchData = (distanceData, branchId) => {
  const data = distanceData.find((data) => data.branchId === branchId);
  return {
    distanceValue: data?.distance,
    distanceFormatted: data?.distance.toLocaleString('id'),
  };
};
export default getDistanceBranchData;
